import { FC } from 'react';

import { DateGranularity } from '#/client/models';
import { CommonInputTextProps } from '#/components/Form/FormInput/FormInput.types';
import { FormInputVariants } from '#/service/constants';

import { useInputTimestamp } from './InputTimestamp.hook';
import { SplitTimestamp } from './SplitTimestamp';

export const InputTimestamp: FC<CommonInputTextProps> = (props) => {
  const { dataKey, displayConfiguration = {} } = props;
  const { granularity } = displayConfiguration;

  const {
    internalFormState,
    updateInternalState,
    validate,
    setTouched,
    touched,
  } = useInputTimestamp(props);

  return (
    <>
      {granularity !== DateGranularity.TimeOnly && (
        <SplitTimestamp
          {...props}
          dataKey={`${dataKey}_date`}
          inputType={FormInputVariants.DATE}
          inputValue={internalFormState[`${dataKey}_date`]}
          onTouchedChange={setTouched}
          touched={touched}
          updateInputValue={updateInternalState}
          validate={validate}
        />
      )}
      {granularity !== DateGranularity.DateOnly && (
        <SplitTimestamp
          {...props}
          dataKey={`${dataKey}_time`}
          inputType={FormInputVariants.TIME}
          inputValue={internalFormState[`${dataKey}_time`]}
          onTouchedChange={setTouched}
          touched={touched}
          updateInputValue={updateInternalState}
          validate={validate}
        />
      )}
    </>
  );
};
